/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';

import {Point} from '../../popover/common/popover';

import {RowActionService} from './providers/row-action-service';
export class DatagridActionOverflow implements OnDestroy {
public anchorPoint: Point = Point.RIGHT_CENTER;
public popoverPoint: Point = Point.LEFT_CENTER;
/**
 * @param {?} rowActionService
 */
constructor(private rowActionService: RowActionService) {
        this.rowActionService.register();
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.rowActionService.unregister();
    }
/**
 * Tracks whether the action overflow menu is open or not
 */
private _open = false;
/**
 * @return {?}
 */
public get open() {
        return this._open;
    }
/**
 * @param {?} open
 * @return {?}
 */
public set open(open: boolean) {
        const /** @type {?} */ boolOpen = !!open;
        if (boolOpen !== this._open) {
            this._open = boolOpen;
            this.openChanged.emit(boolOpen);
        }
    }
public openChanged = new EventEmitter<boolean>(false);
private openingEvent: any;
/**
 * Shows/hides the action overflow menu
 * @param {?} event
 * @return {?}
 */
public toggle(event: any) {
        this.openingEvent = event;
        this.open = !this.open;
    }
/**
 * @param {?} event
 * @return {?}
 */
public close(event: MouseEvent) {
        /*
         * Because this listener is added synchonously, before the event finishes bubbling up the DOM,
         * we end up firing on the very click that just opened the menu, p
         * otentially closing it immediately every time. So we just ignore it.
         */
        if (event === this.openingEvent) {
            delete this.openingEvent;
            return;
        }
        this.open = false;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dg-action-overflow",
    template: `
        <button (click)="toggle($event)" class="datagrid-action-toggle" #anchor>
            <clr-icon shape="ellipsis-vertical"></clr-icon>
        </button>
        <ng-template [(clrPopoverOld)]="open" [clrPopoverOldAnchor]="anchor" [clrPopoverOldAnchorPoint]="anchorPoint"
                     [clrPopoverOldPopoverPoint]="popoverPoint">
            <div #menu class="datagrid-action-overflow" (clrOutsideClick)="close($event)" [clrStrict]="true">
                <ng-content></ng-content>
            </div>
        </ng-template>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: RowActionService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'open': [{ type: Input, args: ["clrDgActionOverflowOpen", ] },],
'openChanged': [{ type: Output, args: ["clrDgActionOverflowOpenChange", ] },],
};
}

function DatagridActionOverflow_tsickle_Closure_declarations() {
/** @type {?} */
DatagridActionOverflow.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridActionOverflow.ctorParameters;
/** @type {?} */
DatagridActionOverflow.propDecorators;
/** @type {?} */
DatagridActionOverflow.prototype.anchorPoint;
/** @type {?} */
DatagridActionOverflow.prototype.popoverPoint;
/**
 * Tracks whether the action overflow menu is open or not
 * @type {?}
 */
DatagridActionOverflow.prototype._open;
/** @type {?} */
DatagridActionOverflow.prototype.openChanged;
/** @type {?} */
DatagridActionOverflow.prototype.openingEvent;
/** @type {?} */
DatagridActionOverflow.prototype.rowActionService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
